(function (app) {

    app.provider("marketingTrackerEventBuyingUnitApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getTypes = function () {
                            return marketingTrackerApiGateway.get("/EventGroups/BuyingUnits/Types");
                        };

                        service.get = function (eventGroupId, buyingUnitLeaderId) {
                            if (buyingUnitLeaderId) {
                                return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId + "/BuyingUnits/" + buyingUnitLeaderId);
                            } else {
                                return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId + "/BuyingUnits");
                            }
                        };

                        service.getBuyingUnits = function (eventGroupId) {
                            return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId + "/BuyingUnits");
                        };

                        service.updateType = function (eventGroupId, buyingUnitLeaderId, type) {
                            return marketingTrackerApiGateway.put(
                                "/EventGroups/" + eventGroupId + "/BuyingUnits/" + buyingUnitLeaderId + "/Type?type=" + type,
                                {
                                    params: {
                                        type: type
                                    }
                                });
                        };

                        service.updateAppointmentSet = function (eventGroupId, buyingUnitLeaderId, boolean) {
                            return marketingTrackerApiGateway.put(
                                "/EventGroups/" + eventGroupId + "/BuyingUnits/" + buyingUnitLeaderId + "/AppointmentSet?value=" + boolean,
                                {
                                    params: {
                                        value: boolean
                                    }
                                });
                        };

                        service.updateAppointmentKept = function (eventGroupId, buyingUnitLeaderId, boolean) {
                            return marketingTrackerApiGateway.put(
                                "/EventGroups/" + eventGroupId + "/BuyingUnits/" + buyingUnitLeaderId + "/AppointmentKept?value=" + boolean,
                                {
                                    params: {
                                        value: boolean
                                    }
                                });
                        };

                        service.updateInsuranceClosed = function (eventGroupId, buyingUnitLeaderId, value) {
                            return marketingTrackerApiGateway.put(
                                "/EventGroups/" + eventGroupId + "/BuyingUnits/" + buyingUnitLeaderId + "/InsuranceClosed?value=" + value,
                                {
                                    params: {
                                        value: value
                                    }
                                });
                        };

                        service.updateAumClosed = function (eventGroupId, buyingUnitLeaderId, value) {
                            return marketingTrackerApiGateway.put(
                                "/EventGroups/" + eventGroupId + "/BuyingUnits/" + buyingUnitLeaderId + "/AumClosed?value=" + value,
                                {
                                    params: {
                                        value: value
                                    }
                                });
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); // jshint ignore:line